import { ImageObject } from "../types.ts";

export const DEFAULT_IMAGE: ImageObject = {
  "@type": "ImageObject",
  encodingFormat: "image",
  alternateName: "Default Image Placeholder",
  url:
    "https://ozksgdmyrqcxcwhnbepg.supabase.co/storage/v1/object/public/assets/1818/ff6bb37e-0eab-40e1-a454-86856efc278e",
};
